import {
    Button, ButtonGroup, DialogBody, DialogFooter, FormatNumber,
    Grid, GridItem, Separator, Stack, Text
} from "@chakra-ui/react";

import { Form, UI } from "components";
import { API, toaster, Mask } from "config";
import useBankAccounts from "hooks/useBankAccounts";
import useUser from "hooks/useUser";
import useWithdrawals from "hooks/useWithrawals";
import useOptions from "hooks/useOptions";
import { useEffect, useRef, useState } from "react";

export default function Request({ ...props }){
    const submitRef = useRef()
    const user = useUser()
    const bank_accounts = useBankAccounts()
    const withdrawals = useWithdrawals()
    const options = useOptions();

    const [ form, setForm ] = useState({})
    const [ amount, setAmount ] = useState()
    const [ bank_account_id, setBank ] = useState()
    const [ fiscal_note, setFiscalNote ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState()

    const amount_digit = Mask.digit(amount ?? '')
    const enabled = amount_digit >= 153 * 100 && !!bank_account_id
    //&& (amount_digit > 1930 * 100 ? !!fiscal_note : true)

    const handleSubmit = async () => {
        if(!window.confirm('Tem certeza que deseja solicitar o saque?')) return
        setLoading(true)

        try{
            const Form = new FormData;
            Form.append('value', amount)
            Form.append('bank_account_id', bank_account_id)
            if(fiscal_note) Form.append('fiscal_note_file', fiscal_note)
            await API.post('/withdrawals', Form, { headers: { "Content-Type": "multipart/form-data" } })
            toaster.create({ title: 'Pedido de saque realizado', type: 'success' })
            withdrawals.refetch()
            props.onClose()
            setForm({})
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toaster.create({
                title: 'Não foi possível solicitar o saque',
                description: err?.response?.data?.message,
                type: 'warning'
            });
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => { console.log(amount)}, [amount])

    return(
        <UI.Dialog title="Solicitar saque" size="sm" {...props}>
            <DialogBody>
                <Stack gap={4}>

                    <Form.Container submitRef={submitRef} onSubmit={handleSubmit}>

                        <UI.Alert size="sm" colorPalette="gray" title="Atente-se!">Pedidos de saque podem levar até 10 dias para serem processados e não podem ser alterados posteriormente.</UI.Alert>

                        <Form.Field label="Saldo disponível:">
                            <Text fontSize="md" fontWeight="bold" color="green.700"><FormatNumber style="currency" currency="BRL" value={user.data?.consultant?.bonus_balance / 100} /></Text>
                        </Form.Field>

                        <Form.Field required label="Selecione a conta:">
                            <Grid templateColumns="1fr 1fr">
                                { bank_accounts.data?.map(item => <GridItem key={item.id}><UI.Pressable disabled={loading} onClick={() => setBank(item.id)}><UI.Bank selected={bank_account_id===item.id} data={item} /></UI.Pressable></GridItem>)  }
                            </Grid>
                        </Form.Field>

                        <Form.Price
                            required
                            label="Valor do saque:"
                            value={amount}
                            error={errors?.value ?? Mask.digit(amount ?? '0') > user.data?.consultant?.bonus_balance ? 'O valor é maior do que o saldo em conta.' : null}
                            onChange={e => setAmount(e.target.value)}
                            placeholder="R$ 153,00"
                            size="xl"
                            fontSize="lg"
                            fontWeight="bold"
                            helper="Lembre-se o valor mínimo para saque é de R$ 150,00 + taxa de R$ 3,00."
                            disabled={loading}
                        />

                        <UI.Show visible={amount_digit > 1930 * 100}>
                            <Separator />
                            <UI.Alert
                                size="sm"
                                status="info"
                            >
                                Para saques acima de <b>R$ 1.930,00</b> é obrigatório nota fiscal.
                                Você pode anexar agora ou até o dia <b>{options.data?.rawNoteDays || "--"}</b> no histórico
                            </UI.Alert>

                            <Form.Upload.Button
                                // required
                                label="Anexar nota fiscal"
                                placeholder="Clique aqui para anexar a Nota Fiscal"
                                disabled={loading}
                                error={errors?.fiscal_note_file}
                                onFileChange={e => setFiscalNote(e.acceptedFiles?.[0])}
                                helper="Serão aceitos apenas arquivos .pdf"
                            />
                        </UI.Show>

                        <Form.Field label="Regras da Empresa sobre pedidos de saque: ">
                            <a target="_blank" href="/aviso-regras-saque.jpeg"><Button>Visualizar</Button></a>
                        </Form.Field>

                    </Form.Container>

                </Stack>

            </DialogBody>

            <DialogFooter>
                <ButtonGroup size="xs">
                    <Button variant="plain" colorPalette="gray" onClick={props.onClose} disabled={loading}><UI.Icon name="cancel" /> Cancelar</Button>
                    <Button colorPalette="orange" disabled={!enabled} loading={loading} onClick={() => submitRef.current.click()}><UI.Icon name="withdraw" /> Solicitar saque</Button>
                </ButtonGroup>
            </DialogFooter>
        </UI.Dialog>
    )
}
